import { Navigate, Outlet } from "react-router-dom";
import Constants from "../../utils/Constants";
import { useProtectedRouteLogin } from "./useProtectedRouteLogin";
import useProtectedRouteAuthCd from "./useProtectedRouteAuthcd";
import useProtectedRouteMaxage from "./useProtectedMaxage";

// 指定された権限があるかチェック
export const ProtectedRouteAuth = function (authcd : any ) {  

  // ログインチェック
  let auth = useProtectedRouteLogin();

  // 権限チェック
  const role = useProtectedRouteAuthCd(authcd);

  // 日付更新
  useProtectedRouteMaxage();

  // 認証情報NG
  if (!auth) {
    return <Navigate to={Constants.NAVI_LOGIN} />
  }

  // 日付更新
  if (role) {
  }

  // 画面移動
  return role ? (
      <Outlet />
    ) : (
      <Navigate to={Constants.NAVI_FORBIDDEN} replace/>
    );

}